import { useTranslation } from "react-i18next";

import { AppLanguage, currentLanguage, setAppLanguage } from "../../i18n";

const OPTIONS: { code: AppLanguage; label: string }[] = [
  { code: "es", label: "ES" },
  { code: "en", label: "EN" },
];

export const LanguageSwitcher = () => {
  const { t } = useTranslation();
  const selected = currentLanguage();

  return (
    <div className="pp-lang" role="group" aria-label={t("common.language")}>
      {OPTIONS.map((option) => (
        <button
          key={option.code}
          type="button"
          className={selected === option.code ? "is-selected" : undefined}
          aria-pressed={selected === option.code}
          onClick={() => setAppLanguage(option.code)}
        >
          {option.label}
        </button>
      ))}
    </div>
  );
};
